export { useCurrentEnvironment } from './useCurrentEnvironment';
